import clsx from 'clsx';
import * as React from 'react';

interface ListGroupProps extends React.HTMLAttributes<HTMLUListElement> {
  horizontal?: boolean;
}

interface ListGroupItemProps extends React.LiHTMLAttributes<HTMLLIElement> {
  horizontal?: boolean;
}

const ListGroup = React.forwardRef<HTMLUListElement, ListGroupProps>(
  ({ className, horizontal, ...props }, ref) => (
    <ul
      ref={ref}
      className={clsx(
        'flex',
        { 'flex-col': !horizontal, 'flex-row': horizontal },
        className,
      )}
      {...props}
    />
  ),
);
ListGroup.displayName = 'ListGroup';

const ListGroupItem = React.forwardRef<HTMLLIElement, ListGroupItemProps>(
  ({ className, horizontal, ...props }, ref) => (
    <li
      ref={ref}
      className={clsx(
        '-mt-px',
        'inline-flex w-full gap-x-2 border border-border px-4 py-3 text-sm font-medium text-muted-foreground',
        {
          'items-center': horizontal,
          'flex-col': !horizontal,
          'flex-row': horizontal,
          'border-l': horizontal,
          'first:mt-0 first:rounded-t-lg': !horizontal,
          'first:ml-0 first:rounded-l-lg': horizontal,
          'last:rounded-b-lg': !horizontal,
          'last:rounded-r-lg': horizontal,
        },
        className,
      )}
      {...props}
    />
  ),
);
ListGroupItem.displayName = 'ListGroupItem';

export { ListGroup, ListGroupItem };
